import styled from "styled-components";
import { device } from "../../utils/helpers/breakpoints";

export const TopNavContainer = styled.div`
  display: ${(props) => (props.isAdmin ? "none" : "")};
  @media ${device.tablet} {
    display: ${(props) => (props.isAdmin ? "" : "none")};
  }
`;